import { asArray } from "@/lib/asArray";
// Batch 34 · C (P6-F7) — an income / expense account's own IFRS 18 category (mounted in CashFlowAccountSettings with one line).
// Saved through PATCH /coa/{id}/cf-settings { pl_ifrs18_category: "OP" | "INV" | "FIN" | "TAX" | "" } (backend/cash_flow_settings.py);
// read by backend/ifrs18_account_category.py (IFRS 18 P&L) and backend/cash_flow_b34.py (cash flow). Strings: lib/i18n/1260_b34c.js.
import React, { useMemo, useState } from "react";
import { I18N_B34C } from "@/lib/i18n/1260_b34c";

export const PL_CATEGORIES = ["OP", "INV", "FIN", "TAX"];

export default function PlCategorySettings({ rows, lang, busy, save }) {
  const T = (k) => ((I18N_B34C[lang] || I18N_B34C.en).plCat[k]) || I18N_B34C.en.plCat[k];
  const [q, setQ] = useState("");
  const list = useMemo(() => {
    const s = q.trim().toLowerCase();
    return asArray(rows).filter((r) => ["4", "5"].includes((r.fs_mapping || "").trim().charAt(0))
      && (r.pl_ifrs18_category
          || (s && `${r.raw_account_code || ""} ${r.raw_account_name || ""}`.toLowerCase().includes(s)))).slice(0, 50);
  }, [rows, q]);
  const name = (r) => `${r.raw_account_code || ""} ${r.raw_account_name || ""}`.trim();
  return (
    <div data-testid="cf-settings-plcat">
      <div className="text-xs font-semibold">{T("title")}</div>
      <div className="text-[11px] text-muted-foreground">{T("help")}</div>
      <input className="mt-1 w-full rounded border px-2 py-1 text-xs" placeholder={T("filter")} value={q}
             onChange={(e) => setQ(e.target.value)} data-testid="plcat-filter" />
      {list.length === 0 && q.trim() ? <div className="text-[11px] text-muted-foreground">{T("none")}</div> : null}
      {list.map((r) => (
        <label key={r.id} className="flex items-center gap-2 py-0.5">
          <span className="font-mono text-[11px]">{name(r)}</span>
          <select className="rounded border px-1 py-0.5 text-xs" value={r.pl_ifrs18_category || ""} disabled={busy === r.id}
                  onChange={(e) => save(r, { pl_ifrs18_category: e.target.value })} data-testid={`plcat-${r.id}`}>
            <option value="">{T("byCode")}</option>
            {PL_CATEGORIES.map((c) => <option key={c} value={c}>{T(c)}</option>)}
          </select>
          {r.pl_ifrs18_category ? <span className="text-[10px] text-emerald-700">{T("set")}</span> : null}
        </label>
      ))}
    </div>
  );
}
